import trendsHistoryTemplate from './trendsHistory.html';
import './trendsHistory.scss';

export default angular
  .module('main.locations.edit.tabs.trendsHistory', [])

  .directive('editLocationTrendsHistoryTab', () => {
    return {
      restrict: 'E',
      template: trendsHistoryTemplate,
      scope: {},
      controller: ($scope,
                   $filter,
                   $q,
                   utils,
                   config,
                   EditLocationDataProvider,
                   I18nService) => {
        const $t = $filter('translate');
        const locale = I18nService.getLocale()?.code || 'en';
        const serviceStatuses = config.getConfigByKey('serviceStatuses');
        $scope.dataProvider = EditLocationDataProvider.instance;
        $scope.timeFormatStr = $t('datetime.events.date');

        const longDurationFormat = 'w [week] d [day] h [hrs] m [min]';
        const shortDurationFormat = 'w[w] d[d] h[h] m[m]';
        const longSecDurationFormat = longDurationFormat + ' s [sec]';
        const shortSecDurationFormat = shortDurationFormat + ' s[s]';

        moment.updateLocale(locale, {
          durationLabelsShort: {
            s: 'sec',
            ss: 'sec',
            m: 'min',
            mm: 'min',
            h: 'hr',
            hh: 'hrs'
          }
        });

        let chartNavigationPeriod;
        let chartUnit;

        let chart;

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
          navigateLeft: navigateLeft,
          navigateRight: navigateRight,
          canNavigateLeft: canNavigateLeft,
          canNavigateRight: canNavigateRight,
          getTrendIcon: getTrendIcon,
          getStatusColor: getStatusColor,
          onServiceClick: onServiceClick,
          formatValueByUnit: formatValueByUnit
        });

        init();

        function init() {
          initWatchers();
          $scope.loading = true;
          return $q.all([
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.locationTrendsResource.init(),
            $scope.dataProvider.locationTimeZoneIdResource.init(),
            $scope.dataProvider.locationServicesStateResource.init(),
            $scope.dataProvider.locationTimeZoneOffsetResource.init(),
          ])
            .then(() => {
              // initViewModel();
              $scope.loading = false;

              $scope.$watchGroup([
                // 'dataProvider.locationTrendsResource.value',
                'dataProvider.locationServicesStateResource.value'
              ], () => {
                initViewModel();
              }, true);

              // If another trend selected
              $scope.$watch('dataProvider.selectedHistoryTrend', (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                  initViewModel();
                }
              }, true);
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });

        }

        function initWatchers() {
          $scope.$watchGroup([
            'navigationPeriod',
            'selectedTrendId',
            'navigationPeriod.selectedPeriod'
          ], (newValue, oldValue) => {
            if ($scope.navigationPeriod && $scope.selectedTrendId && $scope.navigationPeriod.selectedPeriod) {
              getTrendsHistory();
            }

            // Regain services related to selected trend
            if ($scope.selectedTrendId && newValue[1] !== oldValue[1]) {
              getTrendServices();
            }
          });

          $scope.$on('$destroy', function() {
            if (chart) {
              chart.destroy();
            }
          });
        }

        function initViewModel() {
          const categories = angular.copy($scope.dataProvider.locationTrendsResource.value);
          const selectedCategory = categories.find(category => category.id === $scope.dataProvider.selectedTrendCategory);
          $scope.trends = selectedCategory.trends;
          $scope.services = angular.copy($scope.dataProvider.locationServicesStateResource.value);

          // Getting location timezone offcet
          $scope.locationTimezoneOffset = $scope.dataProvider.locationTimeZoneOffsetResource.value;

          if ($scope.trends.length === 0) {
            $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
          }

          $scope.selectedTrendId = $scope.dataProvider.selectedHistoryTrend || $scope.selectedTrendId || $scope.trends[0].id;
          $scope.selectedTrend = $scope.trends && $scope.trends.find(el => el.id === $scope.selectedTrendId);
          $scope.dataProvider.selectedHistoryTrend = undefined;

          initNavigationPeriods();
        }

        function initNavigationPeriods() {
          let locationTimezone = $scope.dataProvider.locationTimeZoneIdResource.value;

          // We should limit navigation by Location creation date (minimum date)
          let locationCreationMoment = moment($scope.dataProvider.locationResource.value.creationDateMs).tz(locationTimezone);

          // Current time
          let nowMoment = moment().tz(locationTimezone);

          // #region Periods for recent aggregation
          let recentPeriods = [];

          {
            let dateInPast = nowMoment.clone();

            let startDate = dateInPast.clone().subtract(14, 'd').startOf('d');
            let endDate = dateInPast;

            recentPeriods.push({
              id: 0,
              name: $t('locations.edit.trendsHistory.since') + ` ${startDate.format('ll')}`,
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for recent 45 days aggregation
          let recent45Periods = [];

          {
            let dateInPast = nowMoment.clone();

            let startDate = dateInPast.clone().subtract(44, 'd').startOf('d');
            let endDate = dateInPast;

            recent45Periods.push({
              id: 0,
              name: $t('locations.edit.trendsHistory.since') + ` ${startDate.format('ll')}`,
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });

            for (let i = 1; i < 10; i++) {
              let dateInPast = nowMoment.clone().subtract(45 * (i + 1) - 1, 'd');

              let startDate = dateInPast.clone().startOf('d');
              let endDate = dateInPast.clone().add(45, 'd').startOf('d');

              // Check if we pass minimum date. But our array should have at least one element.
              if (endDate.isSameOrBefore(locationCreationMoment) && recent45Periods.length > 0) {
                break;
              }

              recent45Periods.push({
                id: i,
                name: `${startDate.format('ll')} - ${endDate.clone().subtract(1, 'ms').format('ll')}`,
                startDate: startDate.valueOf(),
                endDate: endDate.valueOf(),
              });
            }
          }

          // #endregion

          // #region Periods for day aggregation
          let dayPeriods = [];
          for (let i = 0; i < 30; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'd');

            let startDate = dateInPast.clone().startOf('d');
            let endDate = dateInPast.clone().add(1, 'd').startOf('d');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(locationCreationMoment) && dayPeriods.length > 0) {
              break;
            }

            dayPeriods.push({
              id: i,
              name: dateInPast.format('LL'),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for week aggregation
          let weekPeriods = [];
          for (let i = 0; i < 24; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'w');

            let startDate = dateInPast.clone().startOf('w');
            let endDate = dateInPast.clone().add(1, 'w').startOf('w');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(locationCreationMoment) && weekPeriods.length > 0) {
              break;
            }

            weekPeriods.push({
              id: i,
              name: `${startDate.format('ll')} - ${endDate.clone().subtract(1, 'ms').format('ll')}`,
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for month aggregation
          let monthPeriods = [];
          for (let i = 0; i < 24; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'M');

            let startDate = dateInPast.clone().startOf('M');
            let endDate = dateInPast.clone().add(1, 'M').startOf('M');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(locationCreationMoment) && monthPeriods.length > 0) {
              break;
            }

            monthPeriods.push({
              id: i,
              name: dateInPast.format('MMMM, YYYY'),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for year aggregation
          let yearPeriods = [];
          for (let i = 0; i < 10; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'y');

            let startDate = dateInPast.clone().startOf('y');
            let endDate = dateInPast.clone().add(1, 'y').startOf('y');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(locationCreationMoment) && yearPeriods.length > 0) {
              break;
            }

            yearPeriods.push({
              id: i,
              name: dateInPast.format('YYYY'),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          $scope.navigationPeriods = [
            {
              id: 'recent',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('locations.edit.trendsHistory.navigation.recent'),
              periods: recentPeriods,
              selectedPeriodId: 0,
              selectedPeriod: recentPeriods[0]
            },
            {
              id: 'recent45',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('locations.edit.trendsHistory.navigation.recent45'),
              periods: recent45Periods,
              selectedPeriodId: 0,
              selectedPeriod: recent45Periods[0]
            },
            // {
            //   id: 'day',
            //   aggregateBy: 'hour',
            //   chartUnit: 'hour',
            //   name: $t('locations.edit.trendsHistory.navigation.day'),
            //   periods: dayPeriods,
            //   selectedPeriodId: 0,
            //   selectedPeriod: dayPeriods[0]
            // },
            {
              id: 'week',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('locations.edit.trendsHistory.navigation.week'),
              periods: weekPeriods,
              selectedPeriodId: 0,
              selectedPeriod: weekPeriods[0]
            },
            {
              id: 'month',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('locations.edit.trendsHistory.navigation.month'),
              periods: monthPeriods,
              selectedPeriodId: 0,
              selectedPeriod: monthPeriods[0]
            },
            // {
            //   id: 'year',
            //   aggregateBy: 'week',
            //   chartUnit: 'month',
            //   name: $t('locations.edit.trendsHistory.navigation.year'),
            //   periods: yearPeriods,
            //   selectedPeriodId: 0,
            //   selectedPeriod: yearPeriods[0]
            // }
          ];
          $scope.navigationPeriodId = 'recent';
        }

        function getTrendsHistory() {
          $scope.loading = true;
          return $scope.dataProvider.getLocationTrendsHistory($scope.selectedTrendId,
            $scope.navigationPeriod.aggregateBy,
            $scope.navigationPeriod.selectedPeriod.startDate,
            $scope.navigationPeriod.selectedPeriod.endDate)

            .then((data) => {
              drawChart(data?.states || []);
              showHistoryTable(data?.states || []);
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function navigateLeft() {
          if (canNavigateLeft()) {
            $scope.navigationPeriod.selectedPeriodId++;
          }
        }

        function navigateRight() {
          if (canNavigateRight()) {
            $scope.navigationPeriod.selectedPeriodId--;
          }
        }

        /**
         * Check if navigation to the past is available
         * @return {boolean}
         */
        function canNavigateLeft() {
          return !!$scope.navigationPeriod
            && !$scope.loading
            && $scope.navigationPeriod.selectedPeriodId < $scope.navigationPeriod.periods.length - 1;
        }

        /**
         * Check if navigation to the future is available
         * @return {boolean}
         */
        function canNavigateRight() {
          return !!$scope.navigationPeriod
            && !$scope.loading
            && $scope.navigationPeriod.selectedPeriodId > 0;
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
        }

        function onServiceClick() {
          $scope.dataProvider.activeTab = 'services';
        }

        function drawChart(history) {
          if (!chart) {
            createChart();
          }

          let data = history
            .sort((a, b) => a.stateDateMs - b.stateDateMs)
            .map(state => ({
              x: state.stateDateMs,
              y: $scope.navigationPeriod.aggregateBy === 'none' ? parseFloat(state.value.value) : state.value.avg
            }));

          chart.data.datasets[0].data = data;
          $scope.showNoDataMessage = data.length === 0;

          let xMin = $scope.navigationPeriod.selectedPeriod.startDate;
          let xMax = $scope.navigationPeriod.selectedPeriod.endDate - 1;

          const xScale = chart.options.scales.xAxes[0];
          xScale.time.unit = $scope.navigationPeriod.chartUnit;
          xScale.ticks.min = xMin;
          xScale.ticks.max = xMax;

          const suggestedYMin = getSuggestedMin();
          const suggestedYMax = getSuggestedMax();
          const yTicks = chart.options.scales.yAxes[0].ticks;
          yTicks.beginAtZero = suggestedYMin === 0;
          yTicks.suggestedMin = suggestedYMin;
          yTicks.suggestedMax = suggestedYMax;

          // We use different values to prevent ticks re-rendering before new data would come
          chartNavigationPeriod = $scope.navigationPeriodId;
          chartUnit = $scope.selectedTrend?.units;

          // Show average line
          let average = $scope.selectedTrend.avg || 0;

          $scope.average = {
            value: formatValueByUnit(average, chartUnit),
            unit: chartUnit
          };

          if (average == null) {
            // server is calculating average...
            $scope.average.mainLabel = $t('locations.edit.trendsHistory.average');
          } else if (!!$scope.selectedTrend.window) {
            $scope.average.mainLabel = $t('locations.edit.trendsHistory.averageWindow', {
              value: $scope.average.value,
              window: $scope.selectedTrend.window
            });
          } else {
            $scope.average.mainLabel = $t('locations.edit.trendsHistory.averageLabel', { value: $scope.average.value });
          }
          // NOTE for real average calculation:
          // $scope.average.mainLabel = average ?
          //   $t('locations.edit.trendsHistory.averageDesc',{period: navigationPeriod.name, value: formatValueByUnit(average, chartUnit)})
          //   $t('locations.edit.trendsHistory.average')

          // Annotation value and label
          const annotations = chart.options.annotation.annotations[0];
          annotations.value = average;
          annotations.label.content = $scope.average.value;
          annotations.borderColor = average === 0
            ? 'rgba(142, 167, 218, 0)'
            : 'rgba(142, 167, 218, 1)';
          annotations.label.enabled = average !== 0;

          // Fix average label position (if it's on top or on bottom)
          annotations.label.yAdjust = 0;
          if (average != null) {
            const max = Math.max(
              ...data.map(d => d.y)
                .concat([average, suggestedYMin, suggestedYMax])
                .filter(d => d != null)
            );
            const min = Math.min(
              ...data.map(d => d.y)
                .concat([average, 0, suggestedYMin, suggestedYMax])
                .filter(d => d != null)
            );

            if (max !== min) {
              const ratio = average / (max - min);
              if (ratio > 0.85) {
                annotations.label.yAdjust = 12;
              } else if (ratio < 0.15) {
                annotations.label.yAdjust = -12;
              }
            }
          }

          chart.update();
        }

        /* Show full history of trend */
        function showHistoryTable(data) {
          $scope.history = data || [];
          $scope.chartUnit = chartUnit;
          $('#historyTable').tablesort();
        }

        function getTrendIcon() {
          if (!$scope.selectedTrend || !$scope.selectedTrend.icon) {
            return 'fa-chart-line';
          }
          return 'fa-' + $scope.selectedTrend.icon;
        }

        function getTrendServices() {
          let services = [];
          if ($scope.services && $scope.selectedTrend && $scope.selectedTrend.services) {
            services = $scope.services.filter(el => {
              return $scope.selectedTrend.services.some(s => s === el.id);
            });
          }
          $scope.trendServices = services;
        }

        function getStatusColor(status) {
          let currentStatus = serviceStatuses.find(el => el.id === status);
          return currentStatus.color || 'grey';
        }

        function createChart() {
          const locationTimezone = $scope.dataProvider.locationTimeZoneIdResource.value;
          moment.tz.setDefault(locationTimezone);

          let ctx = document.getElementById('trendsHistoryChart');
          let colorHover = 'rgba(142, 167, 218, 1)';
          let gradient = ctx.getContext('2d').createLinearGradient(0, 0, 0, 400);
          let fontFamily = '\'Roboto\', Arial, sans-serif';
          gradient.addColorStop(0, 'rgba(196, 198, 202, 0.9)');
          gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

          Chart.defaults.global.defaultFontFamily = fontFamily;

          /* Custom interaction on hover */
          Chart.defaults.LineWithLine = Chart.defaults.line;
          Chart.controllers.LineWithLine = Chart.controllers.line.extend({
            draw: function(ease) {
              Chart.controllers.line.prototype.draw.call(this, ease);

              // Draw a line on hover
              if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
                let activePoint = this.chart.tooltip._active[0],
                  ctx = this.chart.ctx,
                  x = activePoint.tooltipPosition().x,
                  y = activePoint.tooltipPosition().y,
                  topY = y + 8,
                  bottomY = this.chart.scales['y-axis-0'].bottom,
                  currentAlign = this.chart.options.tooltips.yAlign;

                // Dynamic positioning of the tooltip
                let align = y < 60 ? 'top' : 'bottom';
                if (currentAlign && currentAlign !== align) {
                  this.chart.options.tooltips.yAlign = align;
                  this.chart.update();
                }

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(x, topY);
                ctx.lineTo(x, bottomY);
                ctx.lineWidth = 1;
                ctx.strokeStyle = colorHover;
                ctx.stroke();
                ctx.restore();
              }
            }
          });

          chart = new Chart(ctx, {
            type: 'LineWithLine',
            data: {
              datasets: [
                {
                  label: 'Data',
                  data: [],
                  lineTension: 0,

                  // Background
                  backgroundColor: gradient,

                  // Line
                  borderColor: 'rgba(190, 190, 190, 1)',
                  borderWidth: 2,

                  // Points
                  pointRadius: 6,
                  pointBorderWidth: 2,
                  pointBorderColor: 'rgba(170, 170, 170, 1)',
                  pointBackgroundColor: '#ffffff',
                  pointHoverRadius: 6,
                  pointHoverBorderColor: colorHover,
                  pointHoverBackgroundColor: '#ffffff',
                  pointHoverBorderWidth: 2,

                  spanGaps: true
                }
              ]
            },
            options: {
              layout: {
                padding: {
                  top: 10
                }
              },
              scales: {
                xAxes: [
                  {
                    type: 'time',
                    time: {
                      timezone: $scope.dataProvider.locationTimeZoneIdResource.value,
                      parser: function(date) {
                        return moment(date).tz($scope.dataProvider.locationTimeZoneIdResource.value);
                      }
                    },
                    offset: true,
                    ticks: {
                      maxRotation: 0,
                      autoSkipPadding: 12
                    },
                    gridLines: {
                      borderDash: [4, 4],
                      zeroLineBorderDash: [4, 4],
                      drawTicks: true,
                      offsetGridLines: true,
                      color: 'rgba(0, 0, 0, 0.15)',
                      zeroLineColor: 'rgba(0, 0, 0, 0.15)'
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      maxTicksLimit: 6,
                      suggestedMin: 0,
                      callback: function(value, index, values) {
                        if (chart?.data?.datasets[0]?.data?.length === 0) { // hide ticks if no data present
                          return '';
                        }
                        return formatValueByUnit(value, chartUnit, true);
                      }
                    },
                    gridLines: {
                      drawTicks: true,
                      drawBorder: true,
                      drawOnChartArea: false,
                      zeroLineColor: 'rgba(0, 0, 0, 0)',
                      borderDash: [0, 20],
                    }
                  }
                ]
              },
              legend: {
                display: false
              },
              hover: {
                mode: 'nearest',
                intersect: false
              },
              tooltips: {
                animationDuration: 0,
                caretPadding: 12,
                cornerRadius: 3,
                displayColors: false,
                backgroundColor: colorHover,
                xPadding: 12,
                yPadding: 8,
                xAlign: 'center',
                yAlign: 'bottom',

                // Hovering preference
                mode: 'nearest',
                intersect: false,

                filter: function(tooltipItem) {
                  return tooltipItem?.datasetIndex === 0;
                },
                callbacks: {
                  title: function(tooltipItems, data) {
                    let dataObj = data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index];
                    let date = dataObj.x;

                    if (chartNavigationPeriod === 'day') {
                      return moment(date).format('LT');
                    } else if (chartNavigationPeriod === 'year') {
                      return moment(date).format('MMM');
                    } else { // Recent navigation by days
                      return moment(date).format('ll');
                    }
                  },
                  label: function(tooltipItem, data) {
                    let dataObj = data?.datasets[tooltipItem.datasetIndex]?.data[tooltipItem.index];
                    let value = dataObj?.y;
                    return formatValueByUnit(value, chartUnit);
                  }
                }
              },
              animation: {
                duration: 300
              },
              // ChartJS Annotation plugin
              annotation: {
                annotations: [
                  {
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    borderColor: colorHover,
                    borderWidth: 1,
                    label: {
                      enabled: true,
                      position: 'right',
                      fontFamily: fontFamily,
                      fontColor: 'white',
                      fontStyle: 'normal',
                      backgroundColor: colorHover,
                      xPadding: 8
                    }
                  }
                ]
              }
            }
          });
        }

        /**
         * Format trend value by its unit
         * @param {number|string} value
         * @param {string} [unit]
         * @param {boolean} [short]
         * @return {string}
         */
        function formatValueByUnit(value, unit, short) {
          if (!value) {
            value = 0;
          }
          return utils.formatValueByUnit(value, unit, short);
        }

        function getSuggestedMax() {
          const trend = $scope.selectedTrend;
          if (!trend) {
            return;
          }

          const unit = trend.units;
          const unitLc = trend.units?.toLowerCase();
          const trendId = trend.id;
          const maxVal = trend.max_value;

          if (maxVal != null) {
            return maxVal;
          }

          if (trendId === 'trend.bedtime') {
            return 25; // 1 AM of the next day
          } else if (trendId === 'trend.wakeup') {
            return 12; // 12 PM (noon)
          }

          if (!unit) {
            return undefined;
          } else if (unit === '%') {
            return 100;
          } else if (unitLc === 'timestamp_ms') {
            return 24;
          } else if (unitLc === 'c' || unitLc === 'celsius') {
            return 40;
          } else if (unitLc === 'f' || unitLc === 'fahrenheit') {
            return utils.convertCToF(40);
          }
          return undefined;
        }

        function getSuggestedMin() {
          const trend = $scope.selectedTrend;
          if (!trend) {
            return;
          }
          const trendId = trend.id;
          const minVal = trend.min_value;

          if (minVal != null) {
            return minVal;
          }

          if (trendId === 'trend.bedtime') {
            return 18; // 6 PM
          } else if (trendId === 'trend.wakeup') {
            return 0; // 12 AM (midnight)
          }

          return 0;
        }
      }
    };
  })
  .name;
